module.exports = __webpack_public_path__ + "static/media/artist_06.d1e78a89.png";